module.exports = __webpack_public_path__ + "img/CliEyeSet4.3feb9803.jpeg";